export const handleAxiosError = (error: any) => {
  const errorMessages: any = {};

  if (error.response && error.response.data) {
    const errorData = error.response.data.error;
    Object.keys(errorData).forEach((key) => {
      errorMessages[key] = errorData[key][0]; // Assuming only one error message per field
    });
  } else {
    errorMessages["general"] = "An error occurred. Please try again later.";
  }
  return errorMessages;
};
